module.exports = __webpack_public_path__ + "static/media/img-section03.b3e2e6b1.png";